import React from "react";
import { FmHeading, FmStack, FmText } from "./FmComposition";
import { fmMapOcclusion } from '@/shared/ui/mapOcclusion';

export const MapWorkspaceOrientation: React.FC<{
  ariaLabel: string;
  caption: string;
  ownerQuestion: string;
  literalAnswer: string;
}> = ({ ariaLabel, caption, ownerQuestion, literalAnswer }) => (
  <section
    className="fm-map-workspace__orientation"
    aria-label={ariaLabel}
    data-testid="map-mode-answer"
    {...fmMapOcclusion('top', 'panel')}
  >
    <FmStack gap="xs">
      <FmText size="caption" tone="muted">
        {caption}
      </FmText>
      {/* The owner question is the map route's only page title, so it carries
          the document's h1 while keeping the h2 scale over the live map. */}
      <FmHeading level={1} visualLevel={2}>{ownerQuestion}</FmHeading>
      <FmText>{literalAnswer}</FmText>
    </FmStack>
  </section>
);
